import React, { useState, useEffect, memo } from "react";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import { callPostApi } from "../../services/common/common";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Loader from "./Loader";
import toast from 'react-hot-toast'
import { getWarehouseKeyValueList } from "../../services";
import { Form } from "react-bootstrap";
import Select from "react-select";





const PaginationDataTable = (props) => {
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [wareHouseOption, setWareHouseOptions] = useState([])
    const [selectedWare, setSelectedWare] = useState()

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                let options = [];
                res.responsePacket?.map((d) => {
                    options.push({
                        value: d.key,
                        label: d.value,
                    });
                });
                setWareHouseOptions(options);
                setSelectedWare(options?.[0])
            } else {
                toast(res.message);
            }
        });
    }, [])

    useEffect(() => {
        let jsonRequest = {
            page: currentPage - 1,
            size: perPage,
            search: filterText,

        };
        if (props?.showWareHouse && selectedWare?.value) {
            jsonRequest.warehouseId = selectedWare?.value
        }
        if (props.filter && props.filter !== undefined && props.filter !== "") {
            Object.assign(jsonRequest, props.filter);
        }

        setLoading(true);

        callPostApi(
            props.paginationUrl,
            jsonRequest,
            {},
            (response) => {
                const res = response.responsePacket;
                if (props.serverSidePagination) {
                    setData(res.data);
                    setTotalRows(res.recordsFiltered);
                } else {
                    if (props.filter) {
                        const filteredItems = res.filter((item) =>
                            item.title.toLowerCase().includes(filterText.toLowerCase())
                        );
                        setData(filteredItems);
                    } else {
                        setData(res);
                    }
                    setTotalRows(res.length);
                }
                setLoading(false);
            },
            (error) => {
                setLoading(false);
            }
        );
    }, [props.paginationUrl, props.serverSidePagination, props.columns, perPage, currentPage, filterText, props.filter, props?.showWareHouse ? selectedWare : null]);

    const handleChange = (e) => {
        setCurrentPage(1);
        setFilterText(e.target.value);
    };

    const handleSearchEmptyValue = () => {
        if (filterText.length === 0) {
        }
    };

    const subHeaderComponentMemo = () => (
        <>
            {props?.showWareHouse &&
                <Select
                    options={wareHouseOption}
                    placeholder="Select WareHouse"
                    onChange={(e) => setSelectedWare(e)}
                    value={selectedWare}
                    styles={{
                        option: (base) => ({
                            ...base,
                            textAlign: 'left',
                        }),
                        menu: (base) => ({
                            ...base, minWidth: '200px',
                            
                        }),
                        singleValue: (base) => ({
                            ...base,
                            minWidth: '100px',
                            textAlign: 'left',
                        }),
                        control: (base) => ({
                            ...base,
                            marginRight: '10px',
                          }),
                    }}
                />

            }
            <div className="custom-table-header">
                <div className="d-flex align-items-center">
                    <div className="input-group mr-2 paginationSearchInput">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                <SearchRoundedIcon />
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={filterText}
                            onChange={handleChange}
                        />
                    </div>
                    {!props.showNewBtn && (
                        <div>
                            <div onClick={props.onNewClicked}>
                                <button
                                    id="ember5839"
                                    className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                                    type="button"
                                >
                                    <AddIcon />
                                    New
                                </button>
                            </div>
                        </div>
                    )}
                    {props.storeRackCellPallet && props.showNewBtn && (
                        <div>
                            <div onClick={props.onNewClicked}>
                                <button
                                    id="ember5839"
                                    className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                                    type="button"
                                >
                                    <AddIcon />
                                    New
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

    const customStyles = {
        headCells: {
            style: {
                color: "#000000de",
                fontSize: "14px",
            },
        },
    };

    return props.serverSidePagination ? (
        <DataTable
            className="custom-data-table"
            title=""
            subHeader={props.search}
            subHeaderComponent={props.search && subHeaderComponentMemo()}
            columns={props.columns}
            data={data}
            highlightOnHover
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={setPerPage}
            onChangePage={setCurrentPage}
            customStyles={customStyles}
            progressComponent={<Loader />}
            onRowClicked={props.onRowClicked}
        />
    ) : (
        <DataTable
            className="custom-data-table"
            title=""
            columns={props.columns}
            data={data}
            pagination={props.pagination}
            subHeader={props.search}
            subHeaderComponent={props.search && subHeaderComponentMemo()}
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            progressComponent={<Loader />}
            paginationResetDefaultPage={resetPaginationToggle}
            onRowClicked={props.onRowClicked}
            progressPending={loading}
        />
    );
};

export default memo(PaginationDataTable);
